export type EventContentType =
  | "DIAGNOSTIC_TEST"
  | "TEST"
  | "ML_LESSON"
  | "ML_PRACTICE_SET"
  | "MC_ENTRY_TICKET"
  | "MC_EXIT_TICKET"
  | "BELL_RINGER"
  | "SH_VIDEO"
  | "SH_PRACTICE_SET"
  | "TEACHER_MANUAL"
  | "WORKBOOK"
  | "WORKBOOK_CHAPTER"

export type EventMetadata = {
  eventAction: EventAction
  attempt?: number
  contentType?: EventContentType
  contentRefId?: string
  userId: string
  userRole: string
  score?: number
  timeSpent?: number
  program?: string
  subject?: string
  districtId?: string
  schoolId?: string
  classId?: string
  itemId?: string
}

// Proposed Event Categories
export enum EventCategory {
  USER = "user",
  AUTH = "auth",
  EMAIL = "email",
  NAVIGATION = "navigation",
  TRUSCORE = "truscore",
  MASTERY = "mastery",
  MANAGE = "manage",
  ADMIN = "admin",
  SETTINGS = "act_testSettings",
  STUDY_HALL = "study_hall",
  CLEVER = "clever",
  SCHOOLOGY = "schoology",
  CLASSLINK = "classlink",
  SAML = "saml",
  PRACTICE_TEST = "practice_test",
  BELL_RINGER = "bell_ringer",
  E_BOOKS = "e_books",
  MASTERY_CURRICULUM = "mastery_curriculum"
}

// Proposed Event Actions
// Google analytic events will be named= AnalyticsActions_AnalyticsLabel
export enum EventAction {
  ANSWER = "answer",
  START = "start",
  ADD = "add",
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
  VERIFY = "verify",
  REGISTER = "register",
  LOGIN = "login",
  SESSION_START = "session_start",
  LOGOUT = "logout",
  LOGOUT_INACTIVITY = "logout_inactivity",
  PAUSE = "pause",
  RESUME = "resume",
  FINISH = "finish",
  REQUEST = "request",
  RESTORE = "restore",
  RESET = "reset",
  SESSION = "session",
  INIT = "initAssessment",
  PREVIEW = "preview",
  REVIEW = "review",
  VIEW = "view",
  DOWNLOAD = "download",
  LESSON_COMPLETE = "lesson_complete",
  LESSON_RESUME = "lesson_resume",
  LESSON_START = "lesson_start",
  QUESTION_ANSWERED = "question_answered",
  UPLOAD_VIDEO = "upload_video",
  UPLOAD_PDF = "upload_pdf",
  UPLOAD_IMAGE = "upload_image",
}

// Labels for Actions
export enum EventLabel {
  REPORTING = "reporting",
  USERNAME = "username",
  PASSWORD = "password",
  FAILURE = "failure",
  ERROR = "error",
  DUPE = "dupe",
  EMAIL = "email",
  QUIZ = "quiz",
  STUDENT = "student",
  TEACHER = "teacher",
  SCHOOL_ADMIN = "school_admin",
  DISTRICT_ADMIN = "district_admin",
  SUPER_ADMIN = "super_admin",
  ACT_ADMIN = "act_admin",
  ACT_MULTI_DISTRICT_ADMIN = "act_multi_district_admin",
  SALES_REP = "sales_rep",
  INSTRUCTOR = "instructor",
  COURSE_AUTHOR = "course_author",
  RESET_PASSWORD = "reset_password",
  SUCCESS = "success",
  BAD_PASSWORD = "bad_password",
  EXPIRED_PASSWORD = "expired_password",
  MISSING_ACCOUNT = "missing_account",
  INVALID_CREDENTIALS = "invalid_credentials",
  EDUCATOR = "educator",
  MISSING_CREDENTIALS = "missing_credentials",
  MISSING_INTEGRATION_EMAIL = "missing_intergration_email",
  TEST_SETTINGS = "test_settings",
  CLASS = "class",
  SCHOOL = "school",
  DISTRICT = "district",
  CLEVER = "clever",
  SCHOOLOGY = "schoology",
  CLASSLINK = "classlink",
  SAML = "saml",
  INVITE = "invite"
}
